import { c as _c } from "react/compiler-runtime";
import { Member } from "@/app/(main)/(club)/mes-clubs/[id]/components/edit-event-modal-content";
interface SelectChipsProps {
  value: Member[];
  onChange: (value: Member[]) => void;
}
export const SelectChips: React.FC<SelectChipsProps> = t0 => {
  const $ = _c(5);
  const {
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] !== onChange || $[1] !== value) {
    t1 = value.map(member => <span key={member["@id"]} className="bg-member-blue text-white px-3 py-1 rounded-lg text-sm flex items-center gap-2">{member.firstName} {member.lastName}<button type="button" onClick={() => {
        onChange(value.filter(m => m["@id"] !== member["@id"]));
      }} className="hover:text-red-300">×</button></span>);
    $[0] = onChange;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex flex-wrap gap-2 mb-8">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};